export default __webpack_public_path__ + "static/output-289a7d1210ef9b450bff3cd4cd05bf4e.mp4";